import DeckGL from "@deck.gl/react/typed";
import { useMemo } from "react";
import { TileLayer } from "@deck.gl/geo-layers/typed";
import {
  BitmapBoundingBox,
  BitmapLayer,
  IconLayer,
  IconLayerProps,
  PolygonLayer
} from "@deck.gl/layers/typed";
import { landCover } from "../data/LandCover";
import CulturalPlace from "../assets/icons/CulturalPlace.png";

const INITIAL_VIEW_STATE = {
  longitude: 85.71490102721086,
  latitude: 27.75991528556676,
  zoom: 11,
  pitch: 0,
  bearing: 0,
};

const ICON_MAPPING: IconLayerProps["iconMapping"] = {
  cultural_point: { x: 0, y: 0, width: 400, height: 350, mask: true },
};

const LandCover = () => {

  const layers = useMemo(
    () => [
      new TileLayer({
        // https://wiki.openstreetmap.org/wiki/Slippy_map_tilenames#Tile_servers
        data: "https://c.tile.openstreetmap.org/{z}/{x}/{y}.png",
        minZoom: 0,
        maxZoom: 19,
        tileSize: 256,
        renderSubLayers: (props) => {
          const { boundingBox } = props.tile;
          return new BitmapLayer(props, {
            data: undefined,
            image: props.data,
            bounds: boundingBox.flatMap((x) => x) as BitmapBoundingBox,
          });
        },
      }),

       new PolygonLayer({
        id: "polygon-layer",
        data: landCover,
        pickable: true,
        stroked: true,
        filled: true,
        wireframe: true,
        lineWidthMinPixels: 1,
        getPolygon: (d) => d.coordinates[0],
        getLineColor: [245, 39, 58, 255],
        getFillColor: [245, 39, 58, 0],
        getLineWidth: 1,
      }),
    ],
    []
  );
  return (
    <>
      <DeckGL
        initialViewState={INITIAL_VIEW_STATE}
        controller={true}
        layers={layers}
        getTooltip={({ object }) => object && `${object.name}`}
      ></DeckGL>
    </>
  );
};

export default LandCover;
